import {
  ActionReducerMapBuilder,
  createSlice,
  CreateSliceOptions
} from '@reduxjs/toolkit'

import { fetchSubscriptionsTraceActions } from './Actions'
import { SLICE_NAME } from './Selectors'
import { INITIAL_STATE, T_SUBSCRIPTION_REDUCER } from './TYPES'

const sliceOptions: CreateSliceOptions = {
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (
    builder: ActionReducerMapBuilder<T_SUBSCRIPTION_REDUCER>
  ): void => {
    builder.addCase(
      fetchSubscriptionsTraceActions.success,
      (state, { payload }) => {
        state.subscriptions = payload
      }
    )
  }
}

const slice = createSlice(sliceOptions)

export default slice.reducer
